import { hasAccessRole } from "../../../../services/utils";
import UserRoleEnum from "../../../../constants/UserRoleEnum";
import Colors from "../../../../themes/Colors";

export const getGatewayLabel = (gateway, t) => {
  const map = {
    mercadopago_custom: t("Credit/debit card"),
    mercadopago_basic: t("MercadoPago"),
    publinet: t("Cash/Transfer"),
  };
  return map[gateway] || gateway || "—";
};

export const getPaymentStatusInfo = (status, t) => {
  const map = {
    approved: { label: t("Approved"), color: "#52c41a" },
    pending: { label: t("Pending"), color: Colors.atention },
    in_process: { label: t("Processing"), color: Colors.atention },
    rejected: { label: t("Rejected"), color: "#f96868" },
    cancelled: { label: t("Cancelled"), color: "#f96868" },
    refunded: { label: t("Refunded"), color: Colors.textMuted },
    cancelledin_mediation: { label: t("In dispute"), color: "#f96868" },
    charged_back: { label: t("Voided by claim"), color: "#f96868" },
  };
  return map[status] || { label: status || "—", color: Colors.textMuted };
};

export const getOverallPaymentInfo = (paymentStatus, t) => {
  if (paymentStatus === "pending" || paymentStatus === "pre_approved") {
    return { label: t("Pending"), color: Colors.atention };
  }
  if (paymentStatus === "approved") {
    return { label: t("Approved"), color: "#52c41a" };
  }
  if (paymentStatus === "rejected") {
    return { label: t("Rejected"), color: "#f96868" };
  }
  if (paymentStatus === "cancelled") {
    return { label: t("Cancelled"), color: "#f96868" };
  }
  return { label: t("Pending"), color: Colors.atention };
};

export const isCampaignPaymentPending = (paymentStatus) =>
  paymentStatus === "pending" ||
  paymentStatus === "cancelled" ||
  paymentStatus === "rejected" ||
  paymentStatus === "cancelledin_mediation" ||
  paymentStatus === "charged_back" ||
  paymentStatus === "in_process";

export const hasPendingPayment = (payments) =>
  Array.isArray(payments) && payments.some((p) => p.status === "pending");

export const canCreatePayment = (campaign, isSuperUser) =>
  campaign.external_dsp_id == null || !campaign.smart_campaign || isSuperUser;

export const canShowOdc = (user) =>
  !!user &&
  hasAccessRole(user.roles, [
    UserRoleEnum.agencyMember,
    UserRoleEnum.superModeratorMediaCompany,
    UserRoleEnum.superAdmin,
    UserRoleEnum.planner,
    UserRoleEnum.companyMember,
  ]);

export const getCreatePaymentPath = (campaign) =>
  campaign.new_ssp
    ? `/campaignManager?campaignPayment=${campaign.id}`
    : `/campaign/${campaign.id}/payment`;
